<template>
    <LoaderButton 
        class="btn btn--purple-hollow"
        :class="btnClass"

        :disabled="disabled"
        :loading="store.progression.loading"

        @click="onToggleModal"
    >
        Save Application
    </LoaderButton>

    <DialogModal
        :show="displayModal"
        @close="onToggleModal"
    >
        <template #title>
            <div class="flex justify-between items-center">
                <p>Save Application</p>

                <span 
                    class="w-4 h-4 inline-block rotate-45 cursor-pointer before:transition-colors after:transition-colors before:content-[''] after:content-[''] before:inline-block before:translate-x-px before:w-px before:h-4 before:bg-red after:inline-block after:h-4 after:w-px after:bg-red after:rotate-90" 
                    @click="onToggleModal"
                />
            </div>
        </template>

        <template #content>
            <template v-if="store.progression.details.key === null">
                <p class="!mb-2">Please enter an email address to save your progress. A link will be emailed to this address so you can continue your application.</p>
                <p class="!mb-2">Please note - the saved data will be kept for 30 days and automatically deleted.</p>
            </template>

            <template v-else>
                <p class="!mb-2">When saving additional changes, we will not email you a new link, please use the link previously provided.</p>
                <p class="!mb-2">If you wish to change the email address the save link is sent to please enter it below and we will send a new link to that address.</p>
            </template>
        

            <FormField
                label="Email Address"
                type="text"

                required

                :error="store.progression.actions.submit.errors?.email?.[0]"

                v-model="store.progression.details.email"
            />

        </template>

        <template #footer>
            <LoaderButton 
                v-if="store.progression.details.key"

                class="btn btn--red mr-2"

                :disabled="actionsDisabled"
                :loading="store.progression.actions.delete.loading"

                @click="onToggleConfirmation"
            >
                Delete Application
            </LoaderButton>

            <ConfirmationModal 
                :show="displayConfirmation"
                @close="displayConfirmation = false"
                @confirmed="onConfirmDelete"

                content="Are you sure you wish to delete your application?"
            />

            <LoaderButton 
                class="btn btn--purple-hollow"

                :disabled="actionsDisabled"
                :loading="store.progression.actions.submit.loading"

                @click="onStoreProgress"
            >
                Save Application
            </LoaderButton>
        </template>
    </DialogModal>
</template>

<script>
    import store from "@app/memberships/state/store"
    import DialogModal from '@app/components/modal/DialogModal.vue'
    import ConfirmationModal from '@app/components/modal/ConfirmationModal.vue'
    import FormField from '@app/components/acc/form/FormField.vue'
    import LoaderButton from './LoaderButton.vue'

    export default {
        components: {
            DialogModal,
            FormField,
            LoaderButton,
            ConfirmationModal
        },

        props: {
            disabled : Boolean,
            btnClass : String
        },

        data: function(){
            return {
                store               : store,
                displayModal        : false,
                displayConfirmation : false
            }
        },

        computed: {
            actionsDisabled: function(){
                return this.store.progression.loading
            }
        },

        methods: {
            onToggleModal: function(){
                this.displayModal = !this.displayModal
            },

            onStoreProgress: function(){
                this.store.onStoreProgress()
            },

            onConfirmDelete: function(){
                store.progression.actions.delete.api.execute()
                this.displayConfirmation = false
                this.displayModal = false
            },

            onToggleConfirmation: function(){
                this.displayConfirmation = !this.displayConfirmation
            }
        }
    }
</script>